export default __webpack_public_path__ + "static/media/img6.7dfc9c7e.jpg";